import { Box } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { observer } from 'mobx-react'

import { stringToDateWithTimezone } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import type EmployeeWithShifts from 'modules/shift_management/store/internal/models/EmployeeWithShifts'
import Shift from 'modules/shift_management/store/internal/models/Shift'

import { CREATION_MODE } from '../../../../../store/internal/models/Shift'
import ShiftCellActions from './CellActions/ShiftCellActions'
import ShiftDetails from './Cells/ShiftCell/BaseShift/ShiftLayout/ShiftDetails'

interface Props {
  employee: EmployeeWithShifts
  contractVersions: ContractVersions
}

const EmptyShiftCell = ({ employee, contractVersions }: Props) => {
  const [{ view }] = useSchedule()
  const date = moment()
  const shift = new Shift({
    id: 0,
    employeeId: 0,
    state: 'draft',
    name: i18n.t('shift_management.preview_cell.shift_name'),
    startAt: stringToDateWithTimezone('00:00', 'ui_time'),
    endAt: stringToDateWithTimezone('00:00', 'ui_time'),
    preview: true,
    creationMode: CREATION_MODE.manual,
  })

  // Keep both Boxes to simulate the same height as the ShiftCell and avoid overflow with leaves
  return (
    <Box>
      <Box minHeight={view.cellMinHeight}>
        <ShiftCellActions
          shift={shift}
          selectedDay={date}
          employee={employee}
          preview
          contractVersions={contractVersions}
        >
          <ShiftDetails shift={shift} date={date} preview plannedBreaks={[]} />
        </ShiftCellActions>
      </Box>
    </Box>
  )
}

export default observer(EmptyShiftCell)
